import React from 'react';

import { Guid } from 'src/application/store/model/guid';
import { FroalaEditorsSettings } from 'src/config/configs';

import { dismissedHotspot, viewedTab } from '../../../actions/contentItemActions';
import { useStudentDispatch } from '../../../hooks/useStudentDispatch';
import { getItemByIdTypedSelector } from '../../../store/reducers/items/itemsSelectors';
import { useStudentSelector } from '../../../store/selectors/useStudentSelector';
import { HotspotContent } from './HotspotContent';
import { isHotspotTab } from '@ael/core-api';
import { Transition, TransitionGroup } from 'react-transition-group';

interface HotspotModalProps {
  onDismiss: () => void;
  froalaEditorsSettings: FroalaEditorsSettings;
}

export const HotspotModal: React.FC<HotspotModalProps> = ({ onDismiss, froalaEditorsSettings }) => {
  const hotspot = useStudentSelector((state) => state.currentHotspot.hotspot);
  const dispatch = useStudentDispatch();
  const getItemByIdTyped = useStudentSelector(getItemByIdTypedSelector);
  if (!hotspot) {
    return null;
  }
  const tabs = hotspot.tabs.map((tabId: Guid) => getItemByIdTyped(tabId, isHotspotTab)).toList();

  const dismissHotspot = () => {
    dispatch(dismissedHotspot);
    onDismiss();
  };

  return (
    <TransitionGroup>
      <Transition timeout={450} appear unmountOnExit>
        {(state) => (
          <HotspotContent
            hotspotId={hotspot.id}
            key={hotspot.id}
            tabs={tabs}
            modalSize={hotspot.modalSize}
            onDismiss={dismissHotspot}
            onTabViewed={(tabId: string) => hotspot.id && dispatch(viewedTab(tabId, hotspot.id))}
            state={state}
            froalaEditorsSettings={froalaEditorsSettings}
          />
        )}
      </Transition>
    </TransitionGroup>
  );
};
